export default __webpack_public_path__ + "static/media/service-img-03.512681a7.png";